import AutoSuggestions from '../../Services/Queries/AutoSuggestions'

const MovieAutoSuggestionsdata = async input => {
  try {
    const movieData = await AutoSuggestions(input)
    // console.log(movieData, 'movieDateea')
    return movieData
  } catch (error) {
    return error
  }
}

export default MovieAutoSuggestionsdata
